import {Injectable, NgZone, inject} from '@angular/core'
import {Router} from '@angular/router'
import {App, type URLOpenListenerEvent} from '@capacitor/app'
import {StorageType} from '../entities/enums/storage-type.enum'
import {DecodeService} from './decode.service'
import {InfoService} from './info.service'
import {UveStorageService} from './uve-storage.service'

@Injectable({
  providedIn: 'root',
})
export class DeeplinkService {
  readonly #infoService = inject(InfoService)
  readonly #uveStorageService = inject(UveStorageService)
  readonly #zone = inject(NgZone)
  readonly #router = inject(Router)

  init() {
    if (this.#infoService.isWeb()) {
      return
    }

    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      const slug = this.getPathFromUrl(event)
      if (slug) {
        this.#uveStorageService.set(StorageType.localStorage, 'deeplinkUrl', slug)
      }

      setTimeout(() => {
        this.#zone.run(() => {
          if (this.getDeeplinkUrl()) {
            this.#router.navigateByUrl(slug)
          }
        })
      }, 2000)
    })
  }

  getDeeplinkUrl(): string {
    const url = this.#uveStorageService.get<string>(StorageType.localStorage, 'deeplinkUrl')
    this.#uveStorageService.remove(StorageType.localStorage, 'deeplinkUrl')
    return url
  }

  getPathFromUrl(event: URLOpenListenerEvent) {
    const url = event.url ?? ''
    if (url.startsWith('https://')) {
      // @TODO: check fix regex
      // eslint-disable-next-line no-useless-escape
      const path = url.match(/^(https?:\/\/[^\/?#]+)\/?(.*)/)
      return '/' + path[2]
    } else {
      return '/' + DecodeService.decodeMessage(event.url.split('://').pop())
    }
  }
}
